import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/costs",
		component: lazy(() => import("./CostsPage")),
	},
	{
		path: "/profile/carriers/:carrierId/costs",
		component: lazy(() => import("./CostsPage")),
	},
]);